export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';
//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const DEFAULT_HOSPITAL_INFO = 'default-hospital-info';
export const HOSPITAL_ACTIVITIES = 'hospital-activities';
export const PATIENT_STATISTICS = 'patient-statistics';
export const HRM_BASIC_DATA = 'hrm-basic-data';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//storage setting
export const STORAGE_SETTING = '/storage-configuration';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';

// Contract Settings
export const GET_CONTRACT_SETTINGS = 'get-contract-settings';

// costing settings
export const GET_COST_SETTINGS = 'get-cost-settings';

//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';

//DataTable
export const DATATABLE_DATA = 'crud';
export const DATATABLE_EXPORT = 'export-crud';
export const DATATABLE_SEARCH_SELECT = '/datatable/name';
export const DATATABLE_SERVER_SEARCH_SELECT = '/datatable/serverside/selectable-name';

//Custom TAble
export const CUSTOM_TABLE = 'admin/app/custom-tables';
export const CUSTOM_TABLE_DATA = 'custom-table/values';

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

//Payment Methods
export const PAYMENT_METHOD = '/payment-method';
export const GET_PAYMENT_METHOD_STATUS = '/payment-method-status';
export const GET_STRIPE_STATUS = '/stripe-status';
export const GET_PAYPAL_STATUS = '/paypal-status';
export const GET_RAZORPAY_STATUS = '/razorpay-status';
export const GET_RAZORPAY_INFORMATION = '/razor-pay-information';



// Product and product categories
//DataTable
export const PRODUCTS_DATA = 'products';
export const PRODUCTS_EXPORT = 'export-products';
export const PRODUCTS_SEARCH_SELECT = '/products/name';
export const PRODUCTS_SERVER_SEARCH_SELECT = '/products/serverside/selectable-name';

export const PRODUCT_CATEGORIES_DATA = 'productCategories';
export const PRODUCT_CATEGORIES_SEARCH_SELECT = '/productCategories/name';
export const PRODUCT_CATEGORIES_SERVER_SEARCH_SELECT = '/productCategories/serverside/selectable-name';

// Product and product categories
//DataTable
export const COMPANIESRESOURCES =  'companiesResources'
export const COMPANIES_DATA = 'companies';
export const COMPANIES_EXPORT = 'export-companies';
export const COMPANIES_SEARCH_SELECT = '/companies/name';
export const COMPANIES_SERVER_SEARCH_SELECT = '/companies/serverside/selectable-name';

export const LOCATION_EXPORT = 'export-location';
export const LOCATIONRESOURCES = 'locationResources';
export const LOCATION_SEARCH_SELECT = '/location/name';

export const PACKERSRESOURCES = 'packersResources';
export const PACKERS_SEARCH_SELECT = '/packers/name';

export const BROKERSRESOURCES = 'brokersResources';
export const BROKERS_SEARCH_SELECT = '/brokers/name';

// contract condition
export const CONTRACTCONDITIONRESOURCES = 'contract_conditionResources';
export const CONTRACTCONDITION_SEARCH_SELECT = '/contract_condition/name';

// product type 
export const CONDITIONS_EXPORT = 'export-conditions';
export const CONDITIONSRESOURCES = 'conditionResources';
export const CONDITIONS_SEARCH_SELECT = '/condition/name';

export const PRODUCTTYPEINDEX = '/product_type/index';

// costings
export const COSTINGRESOURCES = 'costingResources';
export const COSTING_SEARCH_SELECT = '/costing/name';

// units 
export const UNITSRESOURCES = 'unitsResources';

// currency
export const CURRENCYRESOURCES = 'currencyResources';
export const CURRENCY_SEARCH_SELECT = '/currency/Code';

// companies
export const COUNTRIES = '/countries/serverside/selectable-name';
// export const STATES = '/productCategories/serverside/selectable-name';
// export const CITIES = '/productCategories/serverside/selectable-name';


// companies-address
export const COMPANIES_ADDRESS = 'address'
export const COMPANIES_CONTACT = 'contacts'


//Suppliers
export const SUPPLIERS_DATA = 'suppliers-data';
export const COMPANIESADDRESS = 'address';
export const COMPANIESCONTACT = 'contacts';



// Contracts
export const CONTRACTS_DATA = 'contracts'; // URL para obtener la lista de contratos
export const CONTRACTS_EXPORT = 'export-contracts'; // URL para exportar contratos
export const CONTRACTS_SEARCH_SELECT = '/contracts/name'; // URL para búsqueda de nombres
export const CONTRACTS_SERVER_SEARCH_SELECT = '/contracts/serverside/selectable-name'; // URL para datos seleccionables en servidor
export const CONTRACTS_SERVER_NUMBER = '/contracts/serverside/contract-number'; // URL para datos seleccionables en servidor
export const CONTRACTS_ADD = 'contracts/add';

// fiscal year
export const FISCAL_YEAR_SERVER_SEARCH_SELECT = '/fiscalYear/serverside/selectable-name';

// Subcontracts
export const SUBCONTRACTS_DATA = 'subcontracts'; // URL para obtener la lista de contratos
export const SUBCONTRACTS_EXPORT = 'subcontracts/export'; // URL para exportar contratos
export const SUBCONTRACTS_SEARCH_SELECT = '/subcontracts/name'; // URL para búsqueda de nombres
export const SUBCONTRACTS_SERVER_SEARCH_SELECT = '/subcontracts/serverside/selectable-name'; // URL para datos seleccionables en servidor
export const SUBCONTRACTS_SERVER_NUMBER = '/subcontracts/serverside/contract-number'; // URL para datos seleccionables en servidor
